<template>
    <ValidationObserver tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
        <CForm method="post" @submit.prevent="handleSubmit(submit)">
            <div class="p-2 b-a-2 bg-white">
                <UserIdentifyTypeComponent v-model="user.identity_type" :disabled="isEditDisabled()" />
                <span class="bg-primary w-100 d-block mb-4" style="height:2px"></span>

                <Loading />
                <Message />

                <CRow>
                    <FaIcon v-if="user.avatar" class="d-block mx-auto mb-2 cursor-pointer" @click="user.avatar = null" icon="close" style="width: 15px;height: 15px;background: red;padding: 7px;border-radius: 50%;color:#fff"/>
                    <CCustomImageInputFile
                        sm="12"
                        :name="$t('user.avatar')"
                        hideLabel
                        vid=""
                        :showProgress="false"
                        v-model="user.avatar"
                        path="avatar"
                        inpClass="b-a-0"
                        class="mx-auto mb-3"
                        @input="avatarLoading"
                        rules="mimes:image/*"
                    >
                        <template #icon-wrapper="{errors}">
                            <Avatar class="text-center mx-auto" :src="user.avatar" maxWidth="100px" />
                            <Loading showIn="avatar" />
                            <span class="text-center invalid-feedback d-block">{{ errors[0] }}</span>
                        </template>
                        <template #invalid>
                            <span></span>
                        </template>
                    </CCustomImageInputFile>

                </CRow>

                <CRow>
                    <CCustomInput
                        v-if="isLegalUser()"
                        col="12" sm="6"
                        vid="legal_name"
                        v-model="user.legal_name"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="$t('user.legal_name')"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        v-if="isLegalUser()"
                        col="12" sm="6"
                        vid="registration_number"
                        :name="$t('user.registration_number')"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        ltr
                        v-model="user.registration_number"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        v-if="isLegalUser()"
                        col="12" sm="6"
                        vid="national_code"
                        :name="$t('user.national_id')"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        ltr
                        v-model="user.national_code"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        v-if="isLegalUser()"
                        col="12" sm="6"
                        vid="economic_code"
                        :name="$t('user.economic_code')"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        ltr
                        v-model="user.economic_code"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="first_name"
                        v-model="user.first_name"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="isRealUser() ? $t('user.first_name') : $t('user.ceo_first_name')"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="last_name"
                        v-model="user.last_name"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="isRealUser() ? $t('user.last_name') : $t('user.ceo_last_name')"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        v-if="isRealUser()"
                        col="12" sm="6"
                        vid="national_code"
                        :name="$t('user.national_code')"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        ltr
                        v-model="user.national_code"
                        :disabled="isEditDisabled()"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="telephone"
                        ltr
                        v-model="user.telephone"
                        :name="$t('user.telephone')"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="province"
                        v-model="user.province"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="$t('user.province')"
                    />

                    <!-- <CCustomInput
                        col="12" sm="6"
                        vid="township"
                        v-model="user.township"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="$t('user.township')"
                    /> -->

                    <CCustomInput
                        col="12" sm="6"
                        vid="city"
                        v-model="user.city"
                        :name="$t('user.city_or_township')"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="postal_code"
                        ltr
                        v-model="user.postal_code"
                        :name="$t('user.postal_code')"
                    />

                    <CCustomTextarea
                        col="12"
                        vid="address"
                        v-model="user.address"
                        :required="!$policy('user').create_any_or_group"
                        :rules="{required: !$policy('user').create_any_or_group}"
                        :name="$t('user.address')"
                    ></CCustomTextarea>

                    <CCustomImageInputFile
                        v-if="isRealUser()"
                        col="12" sm="6"
                        vid="birth_certificate"
                        :name="$t('user.birth_certificate')"
                        v-model="user.birth_certificate"
                        innerLabel
                        showImagePreview
                        path="user_documents"
                        rules="mimes:image/*"
                        :disabled="isEditDisabled()"
                        :scaler="$policy('user').create_any_or_group"
                    >
                        <template #icon>
                            <span class="font-xs d-block">{{ $t('user.upload_your_id_page') }} <span class="text-danger">*</span> </span>
                            <FaIcon icon="cloud-arrow-up" class="fa-2x" />
                        </template>
                    </CCustomImageInputFile>

                    <CCustomImageInputFile
                        v-if="isRealUser()"
                        col="12" sm="6"
                        vid="national_card"
                        :name="$t('user.national_card')"
                        v-model="user.national_card"
                        innerLabel
                        showImagePreview
                        path="user_documents"
                        rules="mimes:image/*"
                        :disabled="isEditDisabled()"
                        :scaler="$policy('user').create_any_or_group"
                    >
                        <template #icon>
                            <span class="font-xs d-block">{{ $t('user.upload_your_national_card_image') }} <span class="text-danger">*</span> </span>
                            <FaIcon icon="cloud-arrow-up" class="fa-2x" />
                        </template>
                    </CCustomImageInputFile>
                </CRow>
            </div>

            <div class="p-2 pt-3 b-a-2 bg-white my-2" v-if="$policy('user').create_any_or_group">
                <CRow>
                    <CCol col="12">
                        <h4>
                            <span>معرفی نماینده</span>
                            <span class="text-muted font-xs d-block font-weight-light">دقت داشته باشید معرفی نماینده صرفا برای اشخاصی است که مدیریت حسابشان توسط شخص دیگری انجام می‌شود.</span>
                        </h4>
                    </CCol>
                    <CCustomInput
                        col="12" sm="6"
                        vid="representative_name"
                        v-model="user.representative_name"
                        :name="$t('user.representative_name')"
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="representative_phone"
                        v-model="user.representative_phone"
                        :name="$t('user.representative_phone')"
                        ltr
                    />

                    <CCustomInput
                        col="12" sm="6"
                        vid="representative_email"
                        v-model="user.representative_email"
                        :name="$t('user.representative_email')"
                        rules="email"
                        ltr
                    />
                </CRow>
            </div>

            <div class="p-2 b-a-2 bg-white mb-3">
                <CRow>
                    <slot name="submitBtn" v-bind:invalid="invalid" v-bind:model="user">
                        <CCol col="12">
                            <CButton :disabled="invalid || !((user.birth_certificate && user.national_card) || $policy('user').create_any_or_group || user.identity_type === UserIdentifyType.LEGAL)" type="submit"  color="primary" class="px-4 mr-auto d-block">{{ $t('btn.submit') }}</CButton>
                        </CCol>
                    </slot>
                </CRow>
            </div>
        </CForm>
    </ValidationObserver>
</template>

<script>
import { UserIdentifyType, UserSetupStatus } from '@/constants'
import { mapActions } from 'vuex'
import UserIdentifyTypeComponent from './UserIdentifyType'

export default {
    name: 'PersonalInformationForm',

    components: {
        UserIdentifyTypeComponent,
    },

    props: {
        user: {
            required: true,
        },
        submit: {
            default: function() {},
            required: true,
        },
    },

    data() {
        return {
            UserIdentifyType,
        }
    },

    watch: {
        'user.city'(val) {
            this.user.township = val
        }
    },

    methods: {
        ...mapActions({
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        avatarLoading(val) {
            if (!val) {
                this.setShowLoading('avatar')
            } else {
                this.setShowLoading(false, 'avatar')
            }
        },
        changeUserIdentifyType(type) {
            this.user.identity_type = type
        },
        isLegalUser() {
            return this.user.identity_type === UserIdentifyType.LEGAL
        },
        isRealUser() {
            return this.user.identity_type === UserIdentifyType.REAL
        },
        isEditDisabled() {
            return [UserSetupStatus.COMPLETE, UserSetupStatus.PENDING_TO_ACTIVE].includes(this.user.setup_status) && !this.$policy('user').create_any_or_group
        }
    }
}
</script>


<style lang="scss" scoped>
.avatar-input-file::v-deep {
    border: none!important;
    .card {

        img {
            border: 3px solid #ab007e!important;
        }
    }
}

</style>